import { render, staticRenderFns } from "./PremiumModalDefaultContentAccountants.vue?vue&type=template&id=72f13f5b&scoped=true&"
import script from "./PremiumModalDefaultContentAccountants.vue?vue&type=script&lang=js&"
export * from "./PremiumModalDefaultContentAccountants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f13f5b",
  null
  
)

export default component.exports